import {
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { BoundedName, BoundedNameDTO } from "../types/boundedName";
/* eslint-disable import/export */
export abstract class AddAllowedDomainRPC implements
  LeoRPC<AddAllowedDomainRPC.Request, AddAllowedDomainRPC.Response, AddAllowedDomainRPC.Errors.Errors>
{
  abstract execute(
    request: AddAllowedDomainRPC.Request
  ): Promise<LeoRPCResult<AddAllowedDomainRPC.Response, AddAllowedDomainRPC.Errors.Errors>>;
}

export namespace AddAllowedDomainRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    domainName: BoundedNameDTO;
    domain: BoundedNameDTO;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isAddAllowedDomainRPCRequest: boolean = true;
  
    readonly domainName: BoundedName;
    readonly domain: BoundedName;
  
  
    constructor(
    domainName: BoundedName, 
    domain: BoundedName
    ) {
      this.domainName = domainName;
      this.domain = domain;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const domainName = BoundedName.fromDTO(getObject(dto, "domainName", InvalidRequestDomainNameError));
      const domain = BoundedName.fromDTO(getObject(dto, "domain", InvalidRequestDomainError));
      return new Request(
        domainName,
        domain
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          domainName: this.domainName.toDTO(),
          domain: this.domain.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `AddAllowedDomainRPC(domainName='${this.domainName}',domain='${this.domain}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `AddAllowedDomainRPC.Response()`;
  };

  export enum RPCError {
    DomainAlreadyExists = "DOMAIN_ALREADY_EXISTS",
    DomainNameAlreadyExists = "DOMAIN_NAME_ALREADY_EXISTS"
  }

  export namespace Errors {
    
    export interface DomainAlreadyExistsDTO {
      code: string;
    }
    
    export class DomainAlreadyExists extends LeoRPCError<RPCError> {
      readonly isDomainAlreadyExists: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.DomainAlreadyExists;
        super(code);
      }
    
    
      toDTO(): DomainAlreadyExistsDTO {
        const dto: DomainAlreadyExistsDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    DomainAlreadyExists.prototype.toString = function toString(): string {
      return `AddAllowedDomainRPC.DOMAIN_ALREADY_EXISTS()`;
    };
    
    
    export interface DomainNameAlreadyExistsDTO {
      code: string;
    }
    
    export class DomainNameAlreadyExists extends LeoRPCError<RPCError> {
      readonly isDomainNameAlreadyExists: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.DomainNameAlreadyExists;
        super(code);
      }
    
    
      toDTO(): DomainNameAlreadyExistsDTO {
        const dto: DomainNameAlreadyExistsDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    DomainNameAlreadyExists.prototype.toString = function toString(): string {
      return `AddAllowedDomainRPC.DOMAIN_NAME_ALREADY_EXISTS()`;
    };
    

    export type Errors = DomainAlreadyExists | DomainNameAlreadyExists;
    export type ErrorsDTO = DomainAlreadyExistsDTO | DomainNameAlreadyExistsDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.DomainAlreadyExists:
          return new DomainAlreadyExists();
        case RPCError.DomainNameAlreadyExists:
          return new DomainNameAlreadyExists();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestDomainNameError extends AddAllowedDomainRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestDomainNameError";
  }
}

export class InvalidRequestDomainError extends AddAllowedDomainRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestDomainError";
  }
}


export class InvalidResponseDomainAlreadyExistsError extends AddAllowedDomainRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDomainAlreadyExistsError";
  }
}

export class InvalidResponseDomainNameAlreadyExistsError extends AddAllowedDomainRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDomainNameAlreadyExistsError";
  }
}

